"use strict";
exports.__esModule = true;
exports.SvgRowAttachmentsHover = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgRowAttachmentsHover = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 14", fill: "none" }, props),
    react_1["default"].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 4a4 4 0 118 0v4.5a2.5 2.5 0 01-5 0v-4a1 1 0 012 0v4a.5.5 0 00.992.09L7.5 8.5V4a2 2 0 10-4 0v4.5a3.5 3.5 0 006.995.192L10.5 8.5v-5a1 1 0 112 0v5a5.5 5.5 0 11-11 0V4z", fill: "#727272" }))); };
//# sourceMappingURL=RowAttachmentsHover.js.map